import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { GameEngine } from '../../hooks/useGameEngine.js';
import { MissionContent } from '../mission/MissionContent.js';
import { unlockMethodEmoji, unlockMethodLabel } from '@shared/unlock.js';
import { formatHeDate, formatHeTime } from '@shared/time.js';
import { plainSnippet } from '@shared/richText.js';
import { gameTimeZone } from '../../lib/gameTime.js';

export function HistoryList() {
  const engine = useOutletContext<GameEngine>();
  const [openId, setOpenId] = useState<string | null>(null);
  const history = [...(engine.state?.history ?? [])].reverse();

  if (history.length === 0) {
    return <div className="empty-state">עדיין לא נפתחו משימות.</div>;
  }

  return (
    <ul className="history-list">
      {history.map((opening) => {
        const expanded = openId === opening.id;
        return (
          <li key={opening.id} className="history-item">
            <button
              type="button"
              className="history-item__row"
              onClick={() => setOpenId(expanded ? null : opening.id)}
              aria-expanded={expanded}
            >
              <span className="history-item__number mono">
                {opening.missionNumber !== null ? `#${opening.missionNumber}` : '—'}
              </span>
              <span className="history-item__snippet">
                {plainSnippet(opening.snapshot.task, 60)}
              </span>
              <span className="history-item__meta mono">
                {formatHeDate(opening.openedAt, gameTimeZone())} {formatHeTime(opening.openedAt, gameTimeZone())}
              </span>
              <span className="history-item__method mono">
                {unlockMethodEmoji(opening.unlockMethod)} {unlockMethodLabel(opening.unlockMethod)}
              </span>
            </button>
            {expanded && (
              <div className="history-item__detail">
                <MissionContent
                  snapshot={opening.snapshot}
                  unlockMethod={opening.unlockMethod}
                  openedAt={opening.openedAt}
                />
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
